<template>
  <div>
    <a-select
      v-model="dateText"
      :placeholder="fieldProps.placeholder"
      :style="{ width: fieldProps.width ? `${fieldProps.width}px` : '200px' }"
      :allowClear="!fieldProps.hideClear"
      @change="onChange"
    >
      <a-select-option
        v-for="(k, kindex) in optionList"
        :key="kindex"
        :value="k.value"
      >
        {{ k.label }}
      </a-select-option>
    </a-select>
  </div>
</template>
<script>
export default {
  name: "SearchSelect",
  props: {
    data: {
      type: String || Number,
      default: "",
    },
    fieldProps: {
      type: Object,
      default: () => ({}),
    },
    keyTime: {
      type: Number,
      default: 0,
    },
    allQuery: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      optionList: [],
    };
  },
  computed: {
    // 查询参数
    dateText: function() {
      return this.data ? JSON.parse(JSON.stringify(this.data)) : undefined;
    },
  },
  watch: {
    keyTime: {
      handler: function() {
        this.firstChange();
      },
      deep: true,
    },
  },
  mounted() {
    this.firstChange();
  },
  methods: {
    firstChange() {
      if (this.fieldProps.option) {
        const newOption = this.fieldProps.option;
        if (String(newOption).includes("findSysCodeType")) {
          // 当是数据字典的下拉匹配时
          this.getSysCodeOption(newOption);
        } else {
          // 普通的接口请求数据匹配
          // console.log(this.fieldProps.associated);
          // console.log(this.fieldProps.ass_ok);
          // console.log(this.allQuery);
          if (this.fieldProps.associated && this.fieldProps.associated.length) {
            if (this.fieldProps.ass_ok) {
              const otherD = {};
              this.fieldProps.associated.forEach((v, index) => {
                otherD[this.fieldProps.otherSear[index]] = this.allQuery[v];
              });
              // console.log(otherD);
              this.getOption(newOption, { ...otherD });
            }
          } else {
            this.getOption(newOption);
          }
        }
      }
    },
    onChange(data) {
      this.$emit("changeBack", data);
    },
    async getOption(func, otherData = {}) {
      const ret = await func(otherData);
      // console.log(ret)
      this.optionList = ret;
    },
    // 当是数据字典的下拉匹配时
    getSysCodeOption(func) {
      if (JSON.stringify(this.$store.state.setting.allSysCode) != "{}") {
        this.getOption(func);
      } else {
        setTimeout(() => {
          this.getSysCodeOption(func);
        }, 200);
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
